"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePackagingProductIfrs = exports.calculateShippingIfrs = void 0;
const taxRates = {
    TEST: 1.19,
    DE: 1.19,
    AT: 1.2,
    CH: 1.077,
};
const getTaxRate = (tenant) => {
    const country = tenant.split('_')[1];
    return taxRates[country];
};
const getIfrs = ({ price, discount = 0, margin = 1, noShow = 0, quantity = 1, offsetShare, taxRate, }) => {
    return (((price - discount) * noShow + ((1 - noShow) * (price * margin - discount)) / taxRate) *
        quantity -
        ((offsetShare * price - offsetShare * discount) * noShow +
            ((1 - noShow) * (offsetShare * price * margin - offsetShare * discount)) / taxRate) *
            quantity);
};
const calculateShippingIfrs = (tenant, price, offsetShare) => {
    const taxRate = getTaxRate(tenant);
    return getIfrs({
        price,
        offsetShare,
        taxRate,
    });
};
exports.calculateShippingIfrs = calculateShippingIfrs;
const calculatePackagingProductIfrs = ({ packaging, tenant, quantity, offsetShare, }) => {
    const taxRate = getTaxRate(tenant);
    const price = packaging.price.gross.amount;
    return getIfrs({
        price,
        offsetShare,
        quantity,
        taxRate,
    });
};
exports.calculatePackagingProductIfrs = calculatePackagingProductIfrs;
//# sourceMappingURL=calculatePackagingProductIfrs.js.map